/* -------------------------------------------------------------------
   outdoer-pdp-buy-block.js

   Puts the current price inside the Add to cart button on mobile.

   Why: benchmarked against Aritzia, whose PDP button reads
   "Add to Bag - $235". Stating the price at the moment of commitment
   removes the last bit of doubt. Ours read only "Add to cart".

   Scope: 749px and below only. The desktop PDP is left alone.

   Separator is a middot, not an em dash, per the Outdoer copy rule.
   ------------------------------------------------------------------- */
(function () {
  var MQ = window.matchMedia('(max-width: 749px)');
  var SEP = ' · ';

  /* The rendered price, read from the DOM rather than computed, so it is
     already formatted and localised by Shopify. The sticky add-to-cart
     bar carries its own .ot-atc__price, so that one is skipped. */
  function priceText() {
    var nodes = document.querySelectorAll('.price, span.price, sale-price');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.closest('.ot-atc')) continue;
      if (!n.getBoundingClientRect().height) continue;
      var t = (n.textContent || '').trim().replace(/\s+/g, ' ');
      var m = t.match(/[^\s]*\d[\d.,]*[^\s]*/);
      if (m) return m[0];
    }
    return null;
  }

  function apply() {
    var label = document.querySelector('add-to-cart-component .add-to-cart-text__content');
    if (!label) return;

    /* Remember the original label once, so repeated runs never stack
       prices onto an already-modified string. */
    if (!label.hasAttribute('data-ot-base')) {
      label.setAttribute('data-ot-base', (label.textContent || '').trim());
    }
    var base = label.getAttribute('data-ot-base');
    var price = MQ.matches ? priceText() : null;
    var want = price ? base + SEP + price : base;

    if ((label.textContent || '').trim() !== want) label.textContent = want;
  }

  function init() {
    apply();

    /* Horizon re-renders the product section on variant change, which
       replaces the button and wipes the label. Same approach as the
       gallery script in outdoer-pdp-enhancements: observe a stable
       parent, and re-apply on a short debounce. */
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(apply, 120);
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') {
        [50, 250, 600, 1200].forEach(function (ms) { setTimeout(apply, ms); });
      }
    });

    if (MQ.addEventListener) MQ.addEventListener('change', apply);
    window.addEventListener('load', function () { setTimeout(apply, 200); });
    [300, 900, 1800].forEach(function (ms) { setTimeout(apply, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
